module.exports = __webpack_public_path__ + "img/geo-zones-2.c057df14.gif";